import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/',
      name: 'newPage',
      meta: {title: '福恋智能'},
      component: (resolve) => require(['@/pages/newPage'], resolve)
    },
    {
      path: '/login',
      name: 'login',
      meta: {title: '登陆'},
      component: (resolve) => require(['@/pages/login'], resolve)
    },
    {
      path: '/merchants',
      name: 'merchants',
      meta: {title: '测试官网'},
      component: (resolve) => require(['@/pages/merchants'], resolve)
    },
    {
      path: '/newPage',
      name: 'newPage',
      meta: {title: '测试官网V2'},
      component: (resolve) => require(['@/pages/newPage'], resolve)
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js